exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-bills-edit-shipping .modal-content .button-row{margin-top:15px}", ""]);

// exports
